<script>
  import { panelState, alwaysVisible, togglePanel, setPanelState } from './GroupButtonsPanelStore.svelte';
  import { Popover } from 'svelte-smooth-popover';
  import Slider from 'svelte-range-slider-pips';
  import 'svelte-range-slider-pips/dist/styles.css';


  export let activeGroup;  
  export let groups;
  export let values1X2;
  export let selectButton;
  export let slicedGroupsColors;
  export let slicedGroups1X2;
  export let antalTecken;
  export let count;
  export let inputFieldMin;
  export let inputFieldMax;
  export let infoMessages;
  export let setGroupMinMax;
  export let currentMin;

  function toggleGroupButton(groupid) {
    if (groupid === activeGroup) {
      togglePanel('peak');
      // setTimeout(() => {  selectButton(0); }, 1000);
      selectButton(0);
    } else if (groupid === 1) {
      selectButton(groupid);
      togglePanel('open1X2');      
    } else {
      selectButton(groupid);
      togglePanel('open');
    }
  }

  function setCurrentMin(id) {
    currentMin = id;
  }

  // $: {
  //     if (groups[5].minMax[0] + groups[6].minMax[0] + groups[7].minMax[0] >= count) {
  //       if (currentMin === 5) {
  //         groups[5].minMax[0] = count - groups[6].minMax[0] - groups[7].minMax[0];
  //         values1X2[currentMin].minMax[0] = groups[5].minMax[0];
  //       }
  //       if (currentMin === 6) {
  //         groups[6].minMax[0] = count - groups[5].minMax[0] - groups[7].minMax[0];
  //         values1X2[currentMin].minMax[0] = groups[6].minMax[0];
  //       }
  //       if (currentMin === 7) {
  //         groups[7].minMax[0] = count - groups[6].minMax[0] - groups[5].minMax[0];
  //         values1X2[currentMin].minMax[0] = groups[7].minMax[0];
  //       }
  //     }
  //     if (groups[1].minMax[0] + groups[2].minMax[0] + groups[3].minMax[0] + groups[4].minMax[0] >= count) {
  //       if (currentMin === 1) groups[1].minMax[0] = count - groups[2].minMax[0] - groups[3].minMax[0] - groups[4].minMax[0];
  //       if (currentMin === 2) groups[2].minMax[0] = count - groups[1].minMax[0] - groups[3].minMax[0] - groups[4].minMax[0];
  //       if (currentMin === 3) groups[3].minMax[0] = count - groups[1].minMax[0] - groups[2].minMax[0] - groups[4].minMax[0];
  //       if (currentMin === 4) groups[4].minMax[0] = count - groups[1].minMax[0] - groups[2].minMax[0] - groups[3].minMax[0];
  //     }
  // }

</script>

<div class="groupButtonsArea">
<div class="groupButtons">
  {#each groups as group, index}
    {#if index > 0 && index < 5 }
      <button
        class="tab gr{group.id} {activeGroup === group.id ? 'tab-active' : ''} active{group.active}"
        on:click={toggleGroupButton(group.id)}>
        <!-- {group.name} -->
        {#if group.active == "1"}
              {group.minMax[0]}<img src="/images/minmax.svg" alt="MinMax" title="Min Max" class="active" />{group.minMax[1]}
        {:else if group.active == "0"}
          <img src="/images/minmax.svg" alt="MinMax" title="Min Max" class="inactive" />
        {/if}
        {#if activeGroup === group.id}
          <span class="close-tab-button">×</span>
        {/if}
      </button>
    {/if}
  {/each}

  {#each groups as group, index}
    {#if index == 0}
      <button
        class="tab gr{group.id} {activeGroup === group.id ? 'tab-active' : ''} active{group.active}"
        on:click={toggleGroupButton(group.id)}>
        <!-- {group.name} -->
        {#if groups[5].minMax[0] > 0 || groups[5].minMax[1] < groups[5].max}
        <span class="smallPill1X2">
          {groups[5].minMax[0]}<img src="/images/minmax1.svg" alt="MinMax1" title="Min Max 1" class="active1X2" />{groups[5].minMax[1]}
        </span>
        {/if}
        {#if groups[6].minMax[0] > 0 || groups[6].minMax[1] < groups[6].max}
        <span class="smallPill1X2">
          {groups[6].minMax[0]}<img src="/images/minmaxX.svg" alt="MinMaxX" title="Min Max X" class="active1X2" />{groups[6].minMax[1]}
        </span>
        {/if}
        {#if groups[7].minMax[0] > 0 || groups[7].minMax[1] < groups[7].max}
        <span class="smallPill1X2">
          {groups[7].minMax[0]}<img src="/images/minmax2.svg" alt="MinMax2" title="Min Max 2" class="active1X2" />{groups[7].minMax[1]}
        </span>
        {/if}
        {#if group.active == "0"}
        <img src="/images/minmax.svg" alt="MinMax" title="Min Max" class="inactive" />
        {/if}
        {#if activeGroup === group.id}
          <span class="close-tab-button">×</span>
        {/if}
        </button>
    {/if}
  {/each}

<!--  <button
    class="tab"
    style="background-color: orange"
    >
    <img src="/images/moneybag.svg" alt="Utdelning" title="Utdelning" class="inactive" />
  </button> -->

</div>

  <!-- Basic settings content -->

{#if activeGroup === 0}
  <div class="tab-content">
    {#if antalTecken[0] + antalTecken[1] + antalTecken[2] < count}
      {infoMessages[0]}
    {:else if antalTecken[0] + antalTecken[1] + antalTecken[2] === count}
      {infoMessages[1]}
    {/if} 
  </div>
{/if}

{#if activeGroup == 1}
           <!-- <div class="tab-content gr{activeGroup}"> -->
  <div class="desktop">
    <div class="tab-content gr1X2">
      {#each slicedGroups1X2 as slice}
        {#if activeGroup == 1}
        <!-- <div class="tab-content gr{activeGroup}"> -->
          {#if antalTecken[0] + antalTecken[1] + antalTecken[2] === count}
        <!-- <div class="numberInputsSection"> -->
            <div class="buttonGroup">
              <div class="numberPills">
                <div class="numberButtonPill pill-1">
                  <button
                    class="decrease"
                    on:click={() => {inputFieldMin(slice.row,'decrease')}} 
                    disabled={groups[slice.row].disabled}
                  >-</button>
                  <span disabled={groups[slice.row].disabled}><img src="/images/min.svg" alt="Min" title="Min" class="active" /></span>
                  <input type="number"
                    bind:value={groups[slice.row].minMax[0]}
                    min=0
                    max={groups[slice.row].max}
                    on:input={() => {inputFieldMin(slice.row,'input')}}
                    on:input={(e) => {setCurrentMin(slice.row)}}
                    disabled={groups[slice.row].disabled}
                  />
                  <button
                    class="increase"
                    on:click={() => {inputFieldMin(slice.row,'increase')}}
                    on:click={(e) => {setCurrentMin(slice.row)}}
                    disabled={groups[slice.row].disabled}
                  >+</button>
                </div>
              </div>
              <div class="info">
                {groups[slice.row].name}
              </div>
              <div class="numberPills">
                <div class="numberButtonPill pill-1">
                  <button
                    class="decrease"
                    on:click={() => {inputFieldMax(slice.row,'decrease')}}
                    disabled={groups[slice.row].disabled}
                  >-</button>
                  <span disabled={groups[slice.row].disabled}>
                    <img src="/images/max.svg" alt="Max" title="Max" class="active" />
                  </span>
                  <input type="number"
                    bind:value={groups[slice.row].minMax[1]}
                    min=0
                    max={groups[slice.row].max}
                    on:input={() => {inputFieldMax(slice.row,'input')}}
                    disabled={groups[slice.row].disabled}
                  />
                  <button
                    class="increase"
                    on:click={() => {inputFieldMax(slice.row,'increase')}}
                    disabled={groups[slice.row].disabled}
                  >+</button>
                </div>
              </div>
              <div class="info">
                {#if groups[slice.row].id === 7}
                  <img src="/images/info.svg" height="24pt" alt="Info" title="Info" />
                  <Popover 
                    borderRadius={10}
                    caretWidth={15}
                    offset={10}
                    caretCurveAmount={1}
                    caretCurveTopAngle={-15}
                    caretCurveTopStrength={0.3333}
                    caretCurveBottomAngle={15}
                    caretCurveBottomStrength={0.6666}
                    caretSubmerge={true}
                    align={"top-right"}
                    alignAnchor={"top-right"}
                    open={false}
                    showOnHover={true}
                    showOnClick={false}
                    hideOnExternalClick={true}
                  >
                    <div class="popOverInfo">
                      {#if antalTecken[0] + antalTecken[1] + antalTecken[2] === count && antalTecken[1] + antalTecken[2] > 1}
                        {infoMessages[9]}
                      {:else}{infoMessages[10]}
                      {/if}
                    </div>
                  </Popover>
                {/if}
              </div>
            </div>
        <!-- </div> -->
          {:else if antalTecken[0] + antalTecken[1] + antalTecken[2] === count && antalTecken[1] + antalTecken[2] > 0}
              <p class="textbox">{infoMessages[5]}{groups[slice.row].desc}{infoMessages[6]}</p> 
  <!--             {:else if groups[slice.row].max > 0 && groups[slice.row].max < 2}
          En text -->

          {/if}
        {/if}
      {/each}
      {#if antalTecken[0] + antalTecken[1] + antalTecken[2] < count}
          <p class="textbox">{infoMessages[8]}</p> 
      {/if}
    </div> <!--end tab-->    
  </div>

  <div class="mobile">
    <div class="tab-content gr1X2 slider-1">
      {#each slicedGroups1X2 as slice}
        {#if activeGroup == 1}
        <!-- <div class="tab-content gr{activeGroup}"> -->
          {#if antalTecken[0] + antalTecken[1] + antalTecken[2] === count}
        <!-- <div class="numberInputsSection"> -->
            <div class="buttonGroup">
              <div class="info">
                {groups[slice.row].name}
              </div>

                <div class="slider">
                  <Slider
                    range={true}
                    min={0}
                    max={groups[slice.row].max}
                    step={1} 
                    float={false}
                    hoverable={true}
                    disabled={groups[slice.row].disabled}
                    pushy
                    pips
                    all="label"
                    bind:values={values1X2[slice.row].minMax}
                    on:change={(e) => {setGroupMinMax(slice.row)}}
                    on:change={(e) => {setCurrentMin(slice.row)}}
                  />
              </div>


              <div class="info">
                {#if groups[slice.row].id === 7}
                  <img src="/images/info.svg" height="24pt" alt="Info" title="Info" />
                  <Popover 
                    borderRadius={10}
                    caretWidth={15}
                    offset={10}
                    caretCurveAmount={1}
                    caretCurveTopAngle={-15}
                    caretCurveTopStrength={0.3333}
                    caretCurveBottomAngle={15}
                    caretCurveBottomStrength={0.6666}
                    caretSubmerge={true}
                    align={"top-right"}
                    alignAnchor={"top-right"}
                    open={false}
                    showOnHover={true}
                    showOnClick={false}
                    hideOnExternalClick={true}
                  >
                    <div class="popOverInfo">
                      {#if antalTecken[0] + antalTecken[1] + antalTecken[2] === count && antalTecken[1] + antalTecken[2] > 1}
                        {infoMessages[9]}
                      {:else}{infoMessages[10]}
                      {/if}
                    </div>
                  </Popover>
                {/if}
              </div>
            </div>
        <!-- </div> -->
          {:else if antalTecken[0] + antalTecken[1] + antalTecken[2] === count && antalTecken[1] + antalTecken[2] > 0}
              <p class="textbox">{infoMessages[5]}{groups[slice.row].desc}{infoMessages[6]}</p> 
  <!--             {:else if groups[slice.row].max > 0 && groups[slice.row].max < 2}
          En text -->

          {/if}
        {/if}
      {/each}
      {#if antalTecken[0] + antalTecken[1] + antalTecken[2] < count}
          <p class="textbox">{infoMessages[8]}</p> 
      {/if}
    </div> <!--end tab-->  
  </div>
{/if}

<div class="desktop">
        {#each slicedGroupsColors as slice}
          {#if activeGroup == slice.id}
           <!-- <div class="tab-content gr{activeGroup}"> -->
           <div class="tab-content">
            {#if antalTecken[0] + antalTecken[1] + antalTecken[2] === count && antalTecken[1] + antalTecken[2] > 0 && groups[slice.row].max > 0}

            <!-- <div class="numberInputsSection"> -->
            <div class="buttonGroup">
              <div class="numberPills">
                Min
              <div class="numberButtonPill pill-{groups[slice.row].id}">
                <button
                  class="decrease"
                  on:click={() => {inputFieldMin(slice.row,'decrease')}} 
                  disabled={groups[slice.row].disabled}
                >-</button>
                <span disabled={groups[slice.row].disabled}><img src="/images/min.svg" alt="Min" title="Min" class="active" /></span>
                <input type="number"
                  bind:value={groups[slice.row].minMax[0]}
                  min=0
                  max={groups[slice.row].max}
                  on:input={() => {inputFieldMin(slice.row,'input')}}
                  on:input={(e) => {setCurrentMin(slice.row)}}
                  disabled={groups[slice.row].disabled}
                />
                <button
                  class="increase"
                  on:click={() => {inputFieldMin(slice.row,'increase')}}
                  on:click={(e) => {setCurrentMin(slice.row)}}
                  disabled={groups[slice.row].disabled}
                >+</button>
              </div>
            </div>
            <div class="numberPills">
              Max
              <div class="numberButtonPill pill-{groups[slice.row].id}">
                <button
                  class="decrease"
                  on:click={() => {inputFieldMax(slice.row,'decrease')}}
                  disabled={groups[slice.row].disabled}
                >-</button>
                <span disabled={groups[slice.row].disabled}>
                  <img src="/images/max.svg" alt="Max" title="Max" class="active" />
                </span>
                <input type="number"
                  bind:value={groups[slice.row].minMax[1]}
                  min=0
                  max={groups[slice.row].max}
                  on:input={() => {inputFieldMax(slice.row,'input')}}
                  disabled={groups[slice.row].disabled}
                />
                <button
                  class="increase"
                  on:click={() => {inputFieldMax(slice.row,'increase')}}
                  disabled={groups[slice.row].disabled}
                >+</button>
              </div>
            </div>
            <div class="info">
                <img src="/images/info.svg" height="24pt" alt="Info" title="Info" />
                <Popover 
                  borderRadius={10}
                  caretWidth={15}
                  offset={10}
                  caretCurveAmount={1}
                  caretCurveTopAngle={-15}
                  caretCurveTopStrength={0.3333}
                  caretCurveBottomAngle={15}
                  caretCurveBottomStrength={0.6666}
                  caretSubmerge={true}
                  align={"top-right"}
                  alignAnchor={"top-right"}
                  open={false}
                  showOnHover={true}
                  showOnClick={false}
                  hideOnExternalClick={true}
                >
                  <div class="popOverInfo">
                    {#if groups[slice.row].max > 1}
                      {infoMessages[3]}{groups[slice.row].desc}{infoMessages[4]}
                    {:else}{infoMessages[5]}{groups[slice.row].desc}{infoMessages[6]}
                    {/if}
                  </div>
                </Popover>
            </div>
          </div>
            <!-- </div> -->
            {:else if antalTecken[0] + antalTecken[1] + antalTecken[2] === count && antalTecken[1] + antalTecken[2] > 0 && groups[slice.row].max === 0 }
              <p class="textbox">{infoMessages[5]}{groups[slice.row].desc}{infoMessages[6]}</p> 
<!--             {:else if groups[slice.row].max > 0 && groups[slice.row].max < 2}
              En text -->
            {:else}
              <p class="textbox">{infoMessages[2]}{groups[slice.row].desc}{infoMessages[7]}</p> 
            {/if}
          </div> <!--end tab-->
          {/if}
        {/each}
</div>

<div class="mobile">
        {#each slicedGroupsColors as slice}
          {#if activeGroup == slice.id}
           <!-- <div class="tab-content gr{activeGroup}"> -->
           <div class="tab-content slider-{activeGroup}">
            {#if antalTecken[0] + antalTecken[1] + antalTecken[2] === count && antalTecken[1] + antalTecken[2] > 0 && groups[slice.row].max > 0}
            <div class="buttonGroup">
              <div class="slider">
              <Slider
                range={true}
                min={0}
                max={groups[slice.row].max}
                step={1} 
                float={false}
                hoverable={true}
                disabled={false}
                pushy
                pips
                all="label"
                bind:values={groups[slice.row].minMax}
                on:change={(e) => {setCurrentMin(slice.row)}}
              />
            </div>
              <div class="info">
                <img src="/images/info.svg" height="24pt" alt="Info" title="Info" />
                <Popover 
                  borderRadius={10}
                  caretWidth={15}
                  offset={10}
                  caretCurveAmount={1}
                  caretCurveTopAngle={-15}
                  caretCurveTopStrength={0.3333}
                  caretCurveBottomAngle={15}
                  caretCurveBottomStrength={0.6666}
                  caretSubmerge={true}
                  align={"top-right"}
                  alignAnchor={"top-right"}
                  open={false}
                  showOnHover={true}
                  showOnClick={false}
                  hideOnExternalClick={true}
                >
                  <div class="popOverInfo">
                    {#if groups[slice.row].max > 1}
                      {infoMessages[3]}{groups[slice.row].desc}{infoMessages[4]}
                    {:else}{infoMessages[5]}{groups[slice.row].desc}{infoMessages[6]}
                    {/if}
                  </div>
                </Popover>
              </div>
            </div>
            {:else if antalTecken[0] + antalTecken[1] + antalTecken[2] === count && antalTecken[1] + antalTecken[2] > 0 && groups[slice.row].max === 0 }
              <p class="textbox">{infoMessages[5]}{groups[slice.row].desc}{infoMessages[6]}</p> 
<!--             {:else if groups[slice.row].max > 0 && groups[slice.row].max < 2}
              En text -->
            {:else}
              <p class="textbox">{infoMessages[2]}{groups[slice.row].desc}{infoMessages[7]}</p>
            {/if}
          </div> <!--end tab-->
          {/if}
        {/each}
</div>

</div>

<style>
  /* GroupButtons styles */

.groupButtonsArea {
  text-align: center;
/*   padding: 3px; */
  margin: 0 auto;
  width: 100%;
/*   height: auto; */
/*     transition: height 3s ease-out; */
/*   border: 2px solid white; */
}

.tab {
  flex: 1 1 auto;
  min-width: 0;
  cursor: pointer;
  display: inline-block;
  height: 25pt;
  font-size: 12pt;
/*   padding-bottom: 28pt; */
  transition: flex 0.3s ease;
  border-radius: 15pt;
  margin: 0 1pt 2pt 1pt;
  padding: 0;
/*   box-shadow: rgba(255, 255, 255, 0.15) 0px 3px 3px 0px; */
/*   margin-bottom: 0px; */
}

.tab-active {
  flex: 4 4 auto;
  filter: opacity(100%) !important;
/*   height: 3em; */
/*   padding-top: 1em; */
/*   border-radius: 0.5em 0.5em 0 0; */
}

button.tab-active  {
  text-align: center;
  padding-left: 20pt;
  border: 3pt solid whitesmoke !important;
/*   color: white; */
}

.tab-content {
  display: grid;
  grid-template-columns: 1fr; /* Switch to one-column layout */
  justify-content: center;
  align-items: center;
  color: var(--themeColorText);
  height: 50pt;
  transition: opacity 0.3s ease-in-out;
/*   overflow: hidden; */
  background: none;
/*   border-radius: 15pt; */
/*   border: 1pt solid green; */
}

.tab-content.gr1X2 {
  height: 160pt;
  vertical-align: middle;
}


span.smallPill1X2 {
  background-color: rgba(255,255,255,0.2);
  padding: 1pt 4pt 1pt 4pt;
  border-radius: 10pt;
}

.popOverInfo {
  background-color: white !important;
  border: 3pt solid white;
  max-width: 200pt;
  padding: 10pt;
  margin: 0;
  border-radius: 10pt;
}

.groupButtons {
  flex: 1;
  display: flex;
/*   align-items: end; */
  padding: 0;
  transition: opacity 0.3s ease-in-out;
/*     overflow-x: scroll; */
/*   background-color: rgba(255,255,255,0.2);
  border-radius: 20pt;
  padding: 3pt; */
/*   border: 2px solid red; */
/*   background-color: var(--color-1); */
}

.groupButtons button {
  filter: opacity(85%);
  border: 2pt solid whitesmoke;
  padding-bottom: 0;
  margin-bottom: 0;
}

.groupButtons button:hover {
  filter: opacity(100%);
}

.groupButtons button.active0 {
/*   filter: opacity(40%);   */
  border: 1.5pt solid whitesmoke;
}

.groupButtons button img.active {
  height: 8pt;
  padding: 0 2pt 0 2pt;
/*   margin-top: 4pt;   */
}

.groupButtons button img.active1X2 {
  height: 12pt;
  padding: 0 2pt 0 2pt;
  vertical-align: text-top;
  margin-top: 1.5pt;
}

.groupButtons button img.inactive {
  filter: invert(0%) opacity(40%);
  height: 8pt;
/*   padding-top: 4pt; */
}

.gr2 img, .gr5 img {
  filter: invert(100%);
}

.numberInputsSection {
  cursor: pointer;
  display: inline-block;
  transition: flex 0.3s ease;
  border: 0;
  border-radius: 0;
}

input[type="number"] {
  -webkit-appearance: textfield;
  -moz-appearance: textfield;
  appearance: textfield;
}

input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button {
  -webkit-appearance: none;
}

.numberButtonPill {
  display: inline-flex;
  position: relative;
}

.numberButtonPill, .numberButtonPill * {
  box-sizing: border-box;
}

.numberButtonPill.pill-2 img, .numberButtonPill.pill-5 img {
    height: 6pt;
    filter: invert(100%);
}

.numberButtonPill.pill-1 img, .numberButtonPill.pill-3 img, .numberButtonPill.pill-4 img {
    height: 6pt;
    filter: invert(0%);
}

.numberButtonPill.pill-1 button, .numberButtonPill.pill-1 input[type=number] {
  background-color: #1e90ff;
  border-color: white;
  color: white;
}

.numberButtonPill.pill-2 button, .numberButtonPill.pill-2 input[type=number] {
  background-color: #ffd700;
  border-color: white;
  color: black;
}

.numberButtonPill.pill-3 button, .numberButtonPill.pill-3 input[type=number] {
  background-color: #d0342c;
  border-color: white;
  color: white;
}

.numberButtonPill.pill-4 button, .numberButtonPill.pill-4 input[type=number] {
  background-color: #32cd32;
  border-color: white;
  color: white;
}

.numberButtonPill.pill-5 button, .numberButtonPill.pill-5 input[type=number] {
  background-color: #ff69b4;
  border-color: white;
  color: black;
}

.numberButtonPill button {
  margin: 0;
  height: 30pt;
  width: 30pt;
  border: 2pt solid white;
  border-radius: 0;
}

.numberButtonPill button.decrease {
  border-radius: 50% 0 0 50%;
  border: 2pt solid white;
/*   border-right: none; */
  padding-top: 3pt;
  padding-left: 7pt;
}

.numberButtonPill button.increase {
  border-radius: 0 50% 50% 0;
  border: 2pt solid white;
/*   border-left: none; */
  padding-top: 3pt;
  padding-right: 7pt;
}

.numberButtonPill span {
  position: absolute;
  font-size: 9pt;
  text-align: right;
  left: 42pt;
  top: 10pt;
/*   color: black; */
}

.numberButtonPill button:disabled, .numberButtonPill input:disabled {
  filter: opacity(35%);
}

.numberButtonPill span:disabled,
.numberButtonPill span[disabled=true] {
  filter: opacity(35%);
}

.numberButtonPill input[type=number] {
  padding: 0 10pt 0 20pt;
  height: 30pt;
  width: 60pt;
  text-align: right;
  border-top: 2pt solid white;
  border-bottom: 2pt solid white;
  border-left: none;
  border-right: none;
  border-radius: 0;
}

.buttonGroup {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
}

.buttonGroup .slider {
  flex: 7;
}

.buttonGroup .numberPills {
  flex: 3;
  padding-top: 10pt;
/*   border: 1px solid yellow; */
  font-size: 16pt;
  font-weight: 900;
}

.buttonGroup .info {
  flex: 1;
  display: grid;
/*   border: 2pt solid red; */
/*   vertical-align: text-top; */
  justify-content: center;
  align-items: center;
  vertical-align: top;
  font-size: 16pt;
  font-weight: 900;
}

.buttonGroup button {
  flex: 1;
  background: none;
  border: none;
}

.slider-1 {
  --range-slider:          white; /* slider main background color */
  --range-handle-inactive: #1e90ff; /* inactive handle color */
  --range-handle:          #1e90ff; /* non-focussed handle color */
  --range-handle-focus:    #1e90ff; /* focussed handle color */
  --range-pip-active:      white; /* active pips (when handle is on a slider-stop) */
  --range-pip-hover:       white; /* when a slider-stop is hovered */
}

.slider-2 {
  --range-slider:          white; /* slider main background color */
  --range-handle-inactive: #ffd700; /* inactive handle color */
  --range-handle:          #ffd700; /* non-focussed handle color */
  --range-handle-focus:    #ffd700; /* focussed handle color */
  --range-pip-active:      white; /* active pips (when handle is on a slider-stop) */
  --range-pip-hover:       white; /* when a slider-stop is hovered */
}

.slider-3 {
  --range-slider:          white; /* slider main background color */
  --range-handle-inactive: #d0342c; /* inactive handle color */
  --range-handle:          #d0342c; /* non-focussed handle color */
  --range-handle-focus:    #d0342c; /* focussed handle color */
  --range-pip-active:      white; /* active pips (when handle is on a slider-stop) */
  --range-pip-hover:       white; /* when a slider-stop is hovered */
}

.slider-4 {
  --range-slider:          white; /* slider main background color */
  --range-handle-inactive: #32cd32; /* inactive handle color */
  --range-handle:          #32cd32; /* non-focussed handle color */
  --range-handle-focus:    #32cd32; /* focussed handle color */
  --range-pip-active:      white; /* active pips (when handle is on a slider-stop) */
  --range-pip-hover:       white; /* when a slider-stop is hovered */
}

.slider-5 {
  --range-slider:          white; /* slider main background color */
  --range-handle-inactive: #ff69b4; /* inactive handle color */
  --range-handle:          #ff69b4; /* non-focussed handle color */
  --range-handle-focus:    #ff69b4; /* focussed handle color */
  --range-pip-active:      white; /* active pips (when handle is on a slider-stop) */
  --range-pip-hover:       white; /* when a slider-stop is hovered */
}


.gr1 {
  background-color: #1e90ff !important;
  color: white;
}

.gr2 {
  background-color: #ffd700 !important;
}

.gr3 {
  background-color: #d0342c !important;
  color: white;
}

.gr4 {
  background-color: #32cd32 !important;
  color: white;
}

.gr5 {
  background-color: #ff69b4 !important;
}


/* .tab-content .buttonGroup {
  display: inline-flex;
  flex: 7; 
  column-gap: 10px;
} */

.rangeSlider {
  display: inline-flex;
  flex: 7;
  column-gap: 10px;
}

.rangeSlider {
    font-size: 8pt;
  }

.tab-content button {
  flex: 1;
}

p.textbox {
    text-align: center;
  padding: 0 3pt 0 3pt;
}

  .desktop {
    display: inline;
  }

  .mobile {
    display: none;
  }

  .close-tab-button {
    float: right;
    margin: 0 2pt;
    padding: 0 6pt 0 6pt;
    font-size: 12pt;
    color: var(--themeColorText);
    background: none;
    border: none;
  }

  .close-tab-button:hover {
    background: rgba(255,255,255,0.4);
    border-radius: 10pt;
  }

@media (max-width: 768px) {
  .desktop {
    display: none;
  }

  .mobile {
    display: inline;
  }

  .tab-content {
    height: 50pt;
  }

  .tab-content.gr1X2 {
    height: 160pt;
  }
}

:root {
  --range-handle-border:   var(--range-handle); /* handle border color */
  --range-range-inactive:  var(--range-handle-inactive); /* inactive range bar background color */
  --range-range:           var(--range-handle-focus); /* active range background color */
  --range-float-inactive:  var(--range-handle-inactive); /* inactive floating label background color */
  --range-float:           var(--range-handle-focus); /* floating label background color */
  --range-float-text:      white; /* text color on floating label */
  --range-pip:                white; /* color of the base pips */
  --range-pip-text:           var(--range-pip); /* color of the base labels */
  --range-pip-active-text:    var(--range-pip-active); /* active labels (when handle is on a slider-stop) */
  --range-pip-hover-text:     var(--range-pip-hover); /* when a slider-stop is hovered */
  --range-pip-in-range:       var(--range-pip-active); /* pips inside the range */
  --range-pip-in-range-text:  var(--range-pip-active-text); /* labels inside the range */
}

</style>